import React, { ReactNode } from 'react';

import { GradientDot } from '../../..';

interface KpiProps {
    /**
     * The content for the KPI, typically including a label and value
     */
    children: ReactNode;
    /**
     * Color for the GradientDot
     */
    gradientDotColor: GradientDotColor;
    /**
     * Icon to render within the GradientDot
     */
    icon: JSX.Element;
}

/**
 * Renders a single KPI from dashboard.kpis
 */
export const Kpi = ({
    children,
    gradientDotColor,
    icon,
}: KpiProps): JSX.Element => (
    <div className="flex-auto w-1/4 rounded-lg bg-white">
        <div className="m-1 p-4 flex">
            <GradientDot width={50} gradientColor={gradientDotColor}>
                {icon}
            </GradientDot>
            <div className="pl-4">{children}</div>
        </div>
    </div>
);
